import React, { memo, useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import ROUTES from "../../constants/routes";
import { useSelector } from "react-redux";

const RequireAuth = ({ children }) => {
  const isAuthenticatedUser=useSelector((state)=>state.auth.isAuthenticatedUser);
  const userEmail = useSelector((state) => state.auth.email);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const subDomain = queryParams.get('subDomain');
  const emailInURL = queryParams.get('email');

  useEffect(() => {
    if (isAuthenticatedUser && (emailInURL === "EMAIL") && userEmail) {
      const newSearchParams = new URLSearchParams(location.search);
      newSearchParams.set("email", userEmail);

      navigate({
        pathname: location.pathname,
        search: newSearchParams.toString(),
      }, { replace: true });
    }
  }, [isAuthenticatedUser, userEmail, location, emailInURL, navigate]);

  if (!isAuthenticatedUser)
    return (
      <Navigate to={`${ROUTES.AGENT.LOGIN}?subDomain=${subDomain}`} state={{ path: `${location.pathname ?? ROUTES.INDEX}${location.search}` }} /> 
    );

  return <>{children}</>;
};

export default RequireAuth; 